// servicesData.js

export const SERVICE_CATEGORIES = [
  {
    code: "ZNX-COM-11",
    title: "Common Booking",
    description:
      "Reserve a service slot to initiate discussion. Final scope, timeline, and pricing are confirmed after consultation.",
  },
  {
    code: "ZNX-WEB-01",
    title: "Website Development",
    description:
      "Business websites, portfolio sites, landing pages, and fully custom web applications with modern UI and performance.",
  },
  {
    code: "ZNX-APP-02",
    title: "Mobile App Development",
    description:
      "Android and iOS mobile applications designed for scalability, security, and smooth user experience.",
  },
  {
    code: "ZNX-SW-03",
    title: "Custom Software Development",
    description:
      "Tailor-made software solutions aligned with your business workflows, operations, and long-term goals.",
  },
  {
    code: "ZNX-UIUX-04",
    title: "UI / UX Design",
    description:
      "User-centric interface and experience design focused on usability, branding, and conversion optimization.",
  },
  {
    code: "ZNX-HOST-05",
    title: "Web Hosting & Security",
    description:
      "Secure hosting solutions, SSL, backups, server optimization, and protection against common vulnerabilities.",
  },
  {
    code: "ZNX-MNT-06",
    title: "Maintenance & Support",
    description:
      "Ongoing maintenance, bug fixes, performance optimization, updates, and long-term technical support.",
  },
  {
    code: "ZNX-CONS-07",
    title: "IT Consulting",
    description:
      "Strategic IT consulting to improve system architecture, scalability, security, and digital transformation.",
  },
  {
    code: "ZNX-AUTO-08",
    title: "Automation & Integration",
    description:
      "Workflow automation, API integrations, and system connectivity to reduce manual effort and improve efficiency.",
  },
  {
    code: "ZNX-TRAIN-09",
    title: "Training & Internship Programs",
    description:
      "Hands-on training, internships, and skill development programs for students and professionals.",
  },
  {
    code: "ZNX-SUITE-10",
    title: "Complete Digital Suite",
    description:
      "End-to-end digital solution including website, mobile app, software, hosting, and long-term support.",
  },
];
